import React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { Field, FieldProps, FieldMetaProps } from "formik";

export default function FormikInputText({
  name,
  ...props
}: { name: string } & TextFieldProps) {
  return (
    <Field name={name}>
      {({
        field,
        meta,
      }: {
        field: FieldProps;
        meta: FieldMetaProps<string>;
      }) => (
        <TextField
          margin="normal"
          type="text"
          {...props}
          {...field}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
        />
      )}
    </Field>
  );
}
